// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ad-3";
export var contentContainer = "_ad-0";
export var editorContainer = "_ad-1";
export var quillInputForm = "_ad-2";
export var zoneDivider = "_ad-4";